import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { ProductsLoadingDialog } from "./products-loading-dialog/ProductsLoadingDialog";
import { ProductDeleteDialog } from "./product-delete-dialog/ProductDeleteDialog";
import { ProductsDeleteDialog } from "./products-delete-dialog/ProductsDeleteDialog";
import { ProductsFetchDialog } from "./products-fetch-dialog/ProductsFetchDialog";
import { ProductsUpdateStatusDialog } from "./products-update-status-dialog/ProductsUpdateStatusDialog";
import { ProductsCard } from "./ProductsCard";
import { ProductsUIProvider } from "./ProductsUIContext";
import { useLocation } from "react-router-dom";

export function ProductsPage({ history }) {
  const productsUIEvents = {
    newProductButtonClick: () => {
      history.push("/invoice/new");
    },
    openEditProductPage: (id) => {
      history.push(`/invoice/${id}/edit`);
    },
    openDeleteProductDialog: (id) => {
      history.push(`/invoice/${id}/delete`);
    },
    openDeleteProductsDialog: () => {
      history.push(`/invoice/deleteProducts`);
    },
    openFetchProductsDialog: () => {
      history.push(`/invoice/fetch`);
    },
    openUpdateProductsStatusDialog: () => {
      history.push("/invoice/updateStatus");
    },
  };

  return (
    <ProductsUIProvider productsUIEvents={productsUIEvents}>
      <ProductsLoadingDialog />
      <Route path="/invoice/deleteProducts">
        {({ history, match }) => (
          <ProductsDeleteDialog
            show={match != null}
            onHide={() => {
              history.push("/invoice");
            }}
          />
        )}
      </Route>
      <Route path="/invoice/:id/delete">
        {({ history, match }) => (
          <ProductDeleteDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/invoice");
            }}
          />
        )}
      </Route>
      <Route path="/invoice/fetch">
        {({ history, match }) => (
          <ProductsFetchDialog
            show={match != null}
            onHide={() => {
              history.push("/invoice");
            }}
          />
        )}
      </Route>
      <Route path="/invoice/updateStatus">
        {({ history, match }) => (
          <ProductsUpdateStatusDialog
            show={match != null}
            onHide={() => {
              history.push("/invoice");
            }}
          />
        )}
      </Route>
      <ProductsCard />
    </ProductsUIProvider>
  );
}
